'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './membership.routes';
import { ModalBase } from '../shared/modal.base';
import { ISeasonUtilsService, IPickupUtilsService, IOptionsService, IMembership, ISeason } from '../interfaces';

interface BasketType {
    season: string,
    baskets: any[]
}

export class MembershipComponent extends ModalBase {
  $http: ng.IHttpService;
  $state: ng.ui.IStateService;
  Auth;
  OptionsService: IOptionsService;
  SeasonUtils: ISeasonUtilsService;
  PickupUtils: IPickupUtilsService;
  TranslationService: any;

  membership: IMembership;
  registrationSeason: any;
  activeSeason: any;

  baskets: BasketType[] = [];
  
  loading: boolean = true;
  //isSeasonOpened: boolean;
  alertNoRegistrations: boolean = false;
  alertNoBasket: boolean = false;
  alertNoPayment: boolean = false;

  isTotalBasketsPriceAvailable: boolean;

  /*@ngInject*/
  constructor(User, Auth, $http, $uibModal, OptionsService, SeasonUtils: ISeasonUtilsService, PickupUtils, $state, TranslationService) {
    super($uibModal);
    this.Auth = Auth;
    this.$http = $http;
    this.$state = $state;
    this.OptionsService = OptionsService;
    this.SeasonUtils = SeasonUtils;
    this.PickupUtils = PickupUtils;
    this.TranslationService = TranslationService;
  }

  getResolve(basket, user) {
    let scope = this;
    return {
      membership: function () {
        return scope.membership;
      },
      registrationSeason: function() {
        return scope.registrationSeason;
      },
      basket: function () {
        return basket;
      },
      user: function () {
        return user;
      }
    }
  }

  $onInit() {
    this.reload();
  }

  reload(){
      let scope = this;
      scope.alertNoRegistrations = false;
      scope.alertNoBasket = false;
      scope.alertNoPayment = false;

      scope.baskets.forEach(b => {
          b.baskets = [];
      });

      scope.isTotalBasketsPriceAvailable = true;

      // Get member data information
      this.$http.get('/api/memberships/member')
      .then(mem => {
          let data = mem.data as any;

          scope.membership = data as IMembership;

          // Get active season
          scope.OptionsService.getActiveSeason()
          .then(activeSeason => {
              scope.activeSeason = activeSeason;

              // if (scope.activeSeason) {
              //     scope.baskets.push({
              //         season: scope.activeSeason.name,
              //         baskets: [],
              //     });
              // }

              scope.OptionsService.getOpenRegistrationsSeason()
              .then(registrationSeason => {
                  scope.registrationSeason = registrationSeason;

                  // if (scope.registrationSeason && scope.registrationSeason._id !== scope.activeSeason) {
                  //     scope.baskets.push({
                  //         season: scope.registrationSeason.name,
                  //         baskets: [],
                  //     });
                  // }

                  let currentTime = (new Date()).getTime();
                  let fourWeeksTime = 24*60*60*1000*7*4;

                  // If it exists season open registration, it displays the basket information for this season
                  if (scope.registrationSeason && (!scope.membership.baskets || scope.membership.baskets.length==0)) {
                      scope.alertNoBasket = true;

                  } else if (!scope.registrationSeason && (!scope.membership.baskets || scope.membership.baskets.length==0)) {
                      scope.alertNoRegistrations = true;

                  } else {
                      let startRegistrationSeasonTime = (new Date(registrationSeason.firstEventDate)).getTime();

                      let registrationSeasonExtraQuantities = [];
                      let activeSeasonExtraQuantities = [];

                      scope.membership.baskets.forEach(basket => {
                        

                          // ----- REGISTRATION SEASON only

                          if (basket.season && basket.season._id == registrationSeason._id && basket.season._id != activeSeason._id) {
                              // Basket is editable if season started less than one month ago
                              let isBasketEditable = true;
                              if (currentTime - startRegistrationSeasonTime > fourWeeksTime) {
                                isBasketEditable = false;
                              }

                              // Total basket price is not available if some baskets has the price to null
                              if ( (!basket.price || basket.price==null) && !basket.newPrice) {
                                scope.isTotalBasketsPriceAvailable = false;
                                isBasketEditable= true;
                              }

                              // If basket is active, there is not possible to delete the basket
                              let isBasketDeletable = true;
                              if (basket.enable) {
                                isBasketDeletable = false;

                              } else {
                                // Basket is deletable if there is no payment at all.
                                // Payment alert if there is nothing paid till this moment
                                if (basket.payments.every(p => p.amount==0)) {
                                  scope.alertNoPayment = true;
                                  isBasketDeletable = true;
                                  isBasketEditable= true;
                                } else {
                                  isBasketDeletable = false;
                                }
                              }
                              (basket as any).$isbasketEditable = isBasketEditable;
                              (basket as any).$isBasketDeletable = isBasketDeletable;
                                    
                              // Finding extra information (it isn't possible by request database so far)
                              basket.extras.forEach(extra => {
                                registrationSeasonExtraQuantities.push({
                                  extra: scope.registrationSeason.availableExtras.find(e => e._id === extra.extra), 
                                  quantity: extra.quantity,
                                  totalPrice: extra.totalPrice
                                });
                              });
                              (basket as any).extras = registrationSeasonExtraQuantities;
                              registrationSeasonExtraQuantities = [];
                    
                              // Parsing date of Pickup
                              (basket as any).$pickupStartDate = scope.SeasonUtils.getStartDateForPickup(scope.registrationSeason, basket.defaultPickupOption);
                              (basket as any).$pickupEndDate = scope.SeasonUtils.getEndDateForPickup(scope.registrationSeason, basket.defaultPickupOption);

                              // Deadline alerts
                              (basket as any).$deadlineApproaching = false;

                              // Include in the registration array
                              // scope.baskets.forEach(basketGroup => {
                              //     if (basketGroup.season === scope.registrationSeason.name) {
                              //         basketGroup.baskets.push(basket);
                              //     }
                              // });
                              scope.addBasketInSeason(scope.registrationSeason, basket);
                          
                          // ----- ACTIVE SEASON

                          } else if (basket.season && basket.season._id == activeSeason._id) {
                              let isBasketEditable = true;

                              // If basket is active, there is not possible to delete the basket
                              let isBasketDeletable = true;
                              if (basket.enable) {
                                isBasketDeletable = false;
                              }

                              (basket as any).$isbasketEditable = isBasketEditable;
                              (basket as any).$isBasketDeletable = isBasketDeletable;
                                    
                              // Finding extra information (it isn't possible by request database so far)
                              basket.extras.forEach(extra => {
                                let extraRef = scope.activeSeason.availableExtras.find(e => e._id === extra.extra)
                                activeSeasonExtraQuantities.push({
                                  extra: extraRef, 
                                  quantity: extra.quantity,
                                  totalPrice: extra.quantity * extraRef.price
                                });
                              });
                              (basket as any).extras = activeSeasonExtraQuantities;
                              activeSeasonExtraQuantities = [];
                    
                              // Parsing date of Pickup
                              (basket as any).$pickupStartDate = scope.SeasonUtils.getStartDateForPickup(scope.activeSeason, basket.defaultPickupOption);
                              (basket as any).$pickupEndDate = scope.SeasonUtils.getEndDateForPickup(scope.activeSeason, basket.defaultPickupOption);

                              // Deadline alerts
                              (basket as any).$deadlineApproaching = false;

                              // Include in the Active array
                              // scope.baskets.forEach(basketGroup => {
                              //     if (basketGroup.season === scope.activeSeason.name) {
                              //         basketGroup.baskets.push(basket);
                              //     }
                              // });
                              scope.addBasketInSeason(scope.activeSeason, basket);
                          
                          // ----- NO ACTIVE SEASON

                          // } else if (basket.season._id !== activeSeason._id && basket.season._id !== scope.registrationSeason._id) {
                          //     (basket as any).$isbasketEditable = false;
                          //     (basket as any).$isBasketDeletable = false;
                          //     (basket as any).extras = [];

                          //     // Parsing date of Pickup
                          //     (basket as any).$pickupStartDate = scope.SeasonUtils.getStartDateForPickup(basket.season, basket.defaultPickupOption);
                          //     (basket as any).$pickupEndDate = scope.SeasonUtils.getEndDateForPickup(basket.season, basket.defaultPickupOption);

                          //     // Include in the NO active array
                          //     scope.baskets.forEach(basketGroup => {
                          //         if (basketGroup.season === scope.activeSeason.name) {
                          //             basketGroup.baskets.push(basket);
                          //         } else {
                          //             scope.baskets.push({
                          //                 season: basket.season.name,
                          //                 baskets: [] = [basket],
                          //             });
                          //         }
                          //     });
                          }

                          // Find the new price
                          basket.season.prices.some(price => {
                              if (price._id === (basket as any).newPrice) {
                                  basket.newPrice = price;
                                  return true;
                              }
                          });

                      }); // End Basket for each
                  }

                  scope.baskets.sort((b1,b2) => {
                      return Number(b1.season) < Number(b2.season) ? 1 : -1;
                  });
              
              }); // End registration season          
            
          }) // End active season
          .catch(err => {
            this.loading = false
          });//End  openRegistrations

          this.loading = false
      })
      // .catch(err => {
      //   console.log(err);
      // })
  }

  private addBasketInSeason(season, basket) {
      let seasonExisted = false;
      this.baskets.forEach(basketGroup => {
          if (basketGroup.season === season.name) {
              seasonExisted = true;
              basketGroup.baskets.push(basket);
          }
      }); 
      
      if (!seasonExisted) {
          this.baskets.push({
              season: basket.season.name,
              baskets: [basket],
          });
      }
  }

  create() {
    let scope = this;
    this.modal('membershipBaskets', this.getResolve(null, null), () => {
      scope.reload();
    });
  }

  deleteBasket(basket) {
    let scope = this;
    let candidate = _.cloneDeep(basket);

    this.modal('membershipBasketDelete', this.getResolve(candidate, null), basketToRemove => {
      this.$http.delete('/api/baskets/' + basketToRemove._id)
      .then(basket => {
        this.reload();
      });
    });
  }

  editBasket(basket) {
    let scope = this;
    
    //Delete privates fields
    let candidate = _.cloneDeep(basket);
    delete candidate.$pickupStartDate;
    delete candidate.$pickupEndDate;
    delete candidate.$isbasketEditable;
    delete candidate.$isBasketDeletable;
    delete candidate.$deadlineApproaching;

    this.modal('membershipBaskets', this.getResolve(candidate, null), () => {
      scope.reload();
    });
  }

  editMembership() {
    let scope = this;
    let currentUser = this.Auth.getCurrentUserSync();
    currentUser.membership = this.membership;
    this.$state.go('settings');
  }

  isExtrasSelected(basket) {
    return basket.extras.length > 0;
  }

  getExtraBases(extra) {
    if (extra.extra.extraBases) {
      return extra.extra.extraBases[this.TranslationService.getCurrentLanguage()=='en' ? 0:1];
    }
    return 0;
  }

  getMemberAddress() {
    let address = '';
    let firstFound = false;
    if (this.membership.address1 && this.membership.address1.length>0) {
      address += this.membership.address1;
      firstFound = true;
    }

    if (this.membership.zip && this.membership.zip.length>0)  {
      if (firstFound) {
        address += '\n' + this.membership.zip;
      } else {
        address += this.membership.zip;
      }
    }

    if (this.membership.city && this.membership.city.length>0)  {
      if (firstFound) {
        address += '\n' + this.membership.city;
      } else {
        address += this.membership.city;
      }
    }

    if (this.membership.country && this.membership.country.length>0)  {
      if (firstFound) {
        address += '\n' + this.membership.country;
      } else {
        address += this.membership.country;
      }
    }
    
    return address;
  }

  getTotalBasket(basket) {
      let total:number = 0;
      if (basket.price) {
          total = basket.price;

      } else if (basket.newPrice) {
          total = basket.newPrice.price;
      }
      total = total + Number(this.getTotalExtrasBasket(basket));
      return total.toFixed(2);
  }

  getBasketPrice(basket) {
      let basketPrice:number = 0;
      
      if (basket.price) {
          basketPrice = basket.price;
      } else if (basket.newPrice) {
          basketPrice = basket.newPrice.price;
      }

      return basketPrice.toFixed(2);
  }

  getTotalExtrasBasket(basket) {
    let total:number = 0;
    for (let extra of basket.extras) {
      total = total + Number(extra.totalPrice);
    }
    return total.toFixed(2);
  }

  getPaymentsBasket(basket) {
    let paid:number = 0;
    for (let pay of basket.payments) {
      paid += Number(pay.amount);
    }
    return paid;
  }

  getTotal(basketGroup) {
    let total:number = 0;
    for (let basket of basketGroup.baskets) {
      total += Number(this.getTotalBasket(basket));
    }
    return total.toFixed(2);
  }

  getTotalPayments(basketGroup) {
    let paid:number = 0;
    for (let basket of basketGroup.baskets) {
      paid += this.getPaymentsBasket(basket); 
    }
    return paid.toFixed(2);
  }

  deadlineApproaching(basket, payment) {
    let currentTime = (new Date()).getTime();
    let weekTime = 24*60*60*1000*7;

    if (payment.amount <= 0
        && (new Date(payment.date)).getTime() - currentTime <= weekTime) {
      //display alert for deadline
      basket.$deadlineApproaching = true;
      return true;
    }
    return false;
  }

}

export default angular.module('terrappApp.membership', [uiRouter])
  .config(routes)
  .component('membership', {
    template: require('./membership.html'),
    controller: MembershipComponent,
    controllerAs: '$ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/membership/membership.component.ts